import debounce from "lodash/debounce";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const setupHeights = (el) => {
  const contentColumn = el.querySelector(".content-column");
  const listColumn = el.querySelector(".list-column");
  const lastElement = listColumn.querySelector(".scroll-sections-placeholder .scroll-section-placeholder:last-child");

  const isTwoColumn = window.matchMedia("(min-width: 768px)").matches;
  const contentHeight = contentColumn.offsetHeight;
  const listHeight = listColumn.offsetHeight;

  if (isTwoColumn && listHeight > contentHeight) {
    const offset = contentColumn.offsetHeight - lastElement.offsetHeight;
    listColumn.style.paddingBottom = `${offset / 2}px`;
  } else {
    listColumn.style.paddingBottom = null;
  }
};

document.querySelectorAll(".element-scrollableexpandingcontent").forEach((el) => {
  setupHeights(el);

  const sectionsPlaceholder = el.querySelector(".scroll-sections-placeholder");
  const contents = el.querySelectorAll(".scroll-content");

  contents.forEach((content) => {
    const height = content.offsetHeight;
    const styles = window.getComputedStyle(content);
    const margin = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
    const padding = parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);

    content.setAttribute("data-height", height + margin + padding);
  });

  gsap.set(contents, { height: 0 });

  const timeline = gsap.timeline({
    paused: true,
    scrollTrigger: {
      trigger: el.querySelector(".scroll-sections"),
      start: "top 35%",
      end: () => {
        return `${sectionsPlaceholder.offsetHeight * 1.2}px center`;
      },
      scrub: true,
      markers: false,
    },
  });

  contents.forEach((content, index) => {
    const section = content.closest(".scroll-section");
    const sectionImage = el.querySelector(`.section-image[data-pos="${section.dataset.index}"]`);
    const prevSection = index > 0 ? contents[index - 1].closest(".scroll-section") : null;

    timeline.to(content, { height: content.dataset.height });

    if (prevSection) {
      const prevSectionImage = el.querySelector(`.section-image[data-pos="${prevSection.dataset.index}"]`);
      timeline.to(prevSection, { className: "scroll-section relative" }, "<");
      timeline.to(prevSectionImage, { opacity: 0, duration: 0.1 }, "<");
    }

    timeline.to(section, { className: "scroll-section relative is-active" }, "<");
    timeline.to(sectionImage, { opacity: 1, duration: 0.1 }, "<");
  });

  ScrollTrigger.refresh();
});

window.addEventListener(
  "resize",
  debounce(() => {
    document.querySelectorAll(".element-scrollableexpandingcontent").forEach((el) => {
      setupHeights(el);
    });
  }, 250),
);
